import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wager-card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "status-row" }
const _hoisted_5 = { class: "date-time" }
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = { class: "bet-amount-row" }
const _hoisted_8 = { class: "bet-amount-value" }
const _hoisted_9 = { class: "id-row" }
const _hoisted_10 = { class: "id-value" }
const _hoisted_11 = { class: "card-details" }
const _hoisted_12 = { class: "detail-row" }
const _hoisted_13 = { class: "detail-value" }
const _hoisted_14 = { class: "detail-row" }
const _hoisted_15 = { class: "detail-value" }


import type { Transaction } from '@/stores/transactions'
import { formatCurrency } from '@/utils/currency'


const __default__ = {
  name: 'WagerCard',
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    transaction: {}
  },
  emits: ["view-details", "rebet"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const handleViewDetails = (event: Event) => {
  event.preventDefault()
  emit('view-details', props.transaction)
}

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

const getStatusClass = (transaction: Transaction) => {
  const statusLower = transaction.bet_status.toLowerCase()
  if (statusLower === 'open') return 'open'
  if (statusLower === 'settled' && Number(transaction.total_winnings || 0) <= 0) return 'settled-zero'
  if (statusLower === 'settled') return 'settled'
  if (statusLower === 'cancelled') return 'cancelled'
  return 'open'
}

const getTotalReturn = (transaction: Transaction) => {
  if (transaction.bet_status.toLowerCase() === 'open') {
    return 'TBC'
  }
  return formatCurrency(transaction.total_winnings, transaction.currency_symbol)
}

const getDrawId = () => {
  return props.transaction.reference ; 
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "status-label" }, "Status:", -1)),
          _createElementVNode("span", {
            class: _normalizeClass(['status-value', getStatusClass(_ctx.transaction)])
          }, _toDisplayString(_ctx.transaction.bet_status), 3)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(formatDate(_ctx.transaction.created_at)), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "bet-amount-label" }, "Bet Amount:", -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formatCurrency)(_ctx.transaction.total, _ctx.transaction.currency_symbol)), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "id-label" }, "BETSLIP ID:", -1)),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.transaction.id), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "detail-row" }, [
        _createElementVNode("span", { class: "detail-label" }, "Description:"),
        _createElementVNode("span", { class: "detail-value" }, "Wager")
      ], -1)),
      _createElementVNode("div", _hoisted_12, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "detail-label" }, "Draw ID:", -1)),
        _createElementVNode("span", _hoisted_13, _toDisplayString(getDrawId()), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "detail-label" }, "Total Return:", -1)),
        _createElementVNode("span", _hoisted_15, _toDisplayString(getTotalReturn(_ctx.transaction)), 1)
      ])
    ]),
    _createElementVNode("div", { class: "card-action" }, [
      _createElementVNode("button", {
        class: "show-more-btn",
        onClick: handleViewDetails
      }, " View details ")
    ])
  ]))
}
}

})